
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import App from './App';
import { ConstancePage } from './pages/ConstancePage';
import { BatchPage } from './pages/BatchPage';
import { ProApp } from './pages/ProApp';
import { ProAppLite } from './PRO/ProAppLite';
import { MediaPage } from './pages/MediaPage';
import { DeletePage } from './pages/DeletePage';
import { StreamPage } from './pages/StreamPage';
import './src/index.css';

// FIX: Use `window.document` to access the DOM.
const rootElement = window.document.getElementById('root');
if (!rootElement) {
  throw new Error("Could not find root element to mount to");
}

const root = ReactDOM.createRoot(rootElement);
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<App />} />
        <Route path="/project/:projectId" element={<App />} />
        <Route path="/constance" element={<ConstancePage />} />
        <Route path="/lot" element={<BatchPage />} />
        <Route path="/pro" element={<ProAppLite />} />
        <Route path="/pro/project/:projectId" element={<ProAppLite />} />
        <Route path="/pro-legacy" element={<ProApp />} />
        <Route path="/pro-legacy/project/:projectId" element={<ProApp />} />
        <Route path="/media" element={<MediaPage />} />
        <Route path="/delete" element={<DeletePage />} />
        <Route path="/stream" element={<StreamPage />} />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>
);
